"use client";
import React, { useState } from "react";
import { Drawer, DrawerContent, DrawerTrigger } from "../../../ui/drawer";
import { Button } from "../../../ui/button";
import { Search } from "lucide-react";
import { CategoryModel } from "@/types/category";
import { PopularSearchModel } from "@/types/search";
import SearchContent from "./search-content";

interface Props {
  popularCategories: CategoryModel[];
  popularSearch: PopularSearchModel[];
  customerSearch: PopularSearchModel[] | null;
}

const MobileSearchDrawer = ({
  popularCategories,
  popularSearch,
  customerSearch,
}: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger>
        <Button size="icon" variant="ghost">
          <Search className="size-5" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="p-4">
        <SearchContent
          popularCategories={popularCategories}
          popularSearch={popularSearch}
          customerSearch={customerSearch}
          setOpen={setOpen}
        />
      </DrawerContent>
    </Drawer>
  );
};

export default MobileSearchDrawer;
